import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import {
  FaChartLine,
  FaCode,
  FaRobot,
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaXTwitter,
  FaWhatsapp,
} from "react-icons/fa6";
import dashboardImg from "../../static/media/dashboard.webp";

export default function TechnologySection() {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#000",
        color: "#fff",
        py: { xs: 3, md: 5 },
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.9) 0%, rgba(128,0,255,0.25) 100%)",
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          maxWidth: "1200px",
          mx: "auto",
          px: { xs: 3, md: 6 },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          gap: { xs: 6, md: 8 },
        }}
      >
        <Box
          component={motion.div}
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: 600,
              color: "#8000FF",
              fontSize: { xs: "1.8rem", md: "2.3rem" },
              mb: 2,
            }}
          >
            Tecnología y Estrategia
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 400,
              color: "#e0e0e0",
              lineHeight: 1.6,
              mb: 3,
              fontSize: { xs: "1rem", md: "1.1rem" },
            }}
          >
            Combinamos IA, automatización y análisis predictivo para construir
            estrategias que evolucionan con tu marca. Cada decisión se respalda
            en datos, precisión y creatividad aplicada.
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(3, 1fr)",
                sm: "repeat(4, 1fr)",
              },
              gap: { xs: 1.5, sm: 2.2, md: 3 },
              justifyItems: "center",
              alignItems: "center",
              mt: 4,
              maxWidth: { xs: 320, sm: "100%" },
              mx: { xs: "auto", md: 0 },
            }}
          >
            {[
              FaChartLine,
              FaCode,
              FaRobot,
              FaFacebookF,
              FaInstagram,
              FaTiktok,
              FaXTwitter,
              FaWhatsapp,
            ].map((Icon, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                viewport={{ once: true }}
              >
                <Box
                  sx={{
                    width: { xs: 58, sm: 70, md: 80 },
                    height: { xs: 58, sm: 70, md: 80 },
                    borderRadius: "50%",
                    background: "rgba(128,0,255,0.16)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 0 22px rgba(128,0,255,0.32)",
                    border: "1px solid rgba(255,255,255,0.12)",
                    transition: "all .3s ease",
                    "&:hover": {
                      transform: "scale(1.12)",
                      background: "rgba(128,0,255,0.28)",
                      boxShadow: "0 0 35px rgba(128,0,255,0.6)",
                    },
                  }}
                >
                  <Icon size={28} color="#fff" />
                </Box>
              </motion.div>
            ))}
          </Box>
        </Box>

        <Box
          component={motion.div}
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: { xs: "85%", sm: "80%", md: "90%" },
              height: { xs: 250, sm: 340, md: 400 },
              borderRadius: 4,
              boxShadow: "0 0 40px rgba(128,0,255,0.35)",
              overflow: "hidden",
            }}
          >
            <motion.img
              src={dashboardImg}
              alt="Dashboard Inteligente Dobledx"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "12px",
              }}
              animate={{
                y: [0, -8, 0],
                x: [0, 4, 0],
              }}
              transition={{
                duration: 5,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}